import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  RouterProvider,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'
import './i18n'
import { getRuntimeEnv } from './lib/runtime-env'
import { AttributionTrackingService } from './services/attribution'
import { ReferralInviteService } from './services/referral'

AttributionTrackingService.captureFromEnvironment()
ReferralInviteService.captureFromEnvironment()

Sentry.init({
  dsn: getRuntimeEnv('VITE_SENTRY_DSN'),
  environment: getRuntimeEnv('VITE_SENTRY_ENVIRONMENT') || 'development',
  enabled: !!getRuntimeEnv('VITE_SENTRY_DSN'),
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 0.2,
})

// Wrap createBrowserRouter so Sentry can attach transactions to the data router.
// Thin shell: `path: '*'` keeps the existing component-based <Routes> tree in App.tsx
// while unlocking useBlocker for unsaved-changes guards.
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
const router = sentryCreateBrowserRouter([{ path: '*', element: <App /> }])

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
)
